import { IconButton, Icons, Typography } from "@fielmann-ag/prisma-components";

interface PageBannerProps {
  variant: "warning" | "error";
  title: string;
  body: string;
  hint?: string;
  closeAria: string;
  onDismiss: () => void;
}

/**
 * Full-width dismissible banner for the page chrome
 * (between main content and the footer).
 */
export function PageBanner({
  variant,
  title,
  body,
  hint,
  closeAria,
  onDismiss,
}: PageBannerProps) {
  const isWarning = variant === "warning";

  return (
    <div
      role="alert"
      className={`flex w-full items-start gap-1.5 overflow-clip px-2 py-1 sm:px-[4.5rem] ${
        isWarning ? "bg-warning-tertiary" : "bg-error-tertiary"
      }`}
    >
      <Icons.Medium.Warning
        className="mt-px size-2 shrink-0"
        aria-hidden="true"
      />
      <div className="flex min-w-0 flex-1 flex-col gap-0.5 py-0.25">
        <Typography as="p" variant="title" size={200} weight="medium">
          {title}
        </Typography>
        <Typography as="p" variant="copy" size={100}>
          {body}
        </Typography>
        {hint ? (
          <Typography as="p" variant="copy" size={100}>
            {hint}
          </Typography>
        ) : null}
      </div>
      <IconButton
        label={closeAria}
        variant="plain"
        size={50}
        icon={<Icons.Medium.Cancel aria-hidden="true" />}
        onPress={onDismiss}
        className="shrink-0"
      />
    </div>
  );
}
